import { DialogDescription, DialogTitle } from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import { Dialog, DialogContent } from '@/components/Dialog';
import VisuallyHidden from '@/components/VisuallyHidden';
import { MAX_SIZE_MB } from '@/config';
import pending from '@/images/validations/pending.svg';
import { cn } from '@/utils';

const errorImages = {
	maxSize: pending,
	unsupportedFormat: pending,
	notFound: pending,
	dimensionsExceeded: pending
};

function ErrorModal({ open, errorCode, onClose }) {
	const { t } = useTranslation();

	if (!errorImages[errorCode]) {
		return null;
	}

	const errorDescriptions = {
		unsupportedFormat: t('editor.errors.unsupportedFormatText')
	};

	const description = errorDescriptions[errorCode];
	const title = t(`editor.errors.${errorCode}`, { maxSize: MAX_SIZE_MB });

	return (
		<Dialog open={open}>
			<DialogContent
				className="flex h-full max-h-[380px] w-[calc(100vw-40px)] max-w-[398px] flex-col items-center justify-center gap-0"
				hasCross={false}
			>
				<img
					className="mb-5"
					src={errorImages[errorCode]}
					alt={errorCode}
				/>
				<DialogTitle
					className={cn('mb-6 whitespace-pre-wrap text-center', {
						'mb-2 font-semibold': !!description
					})}
				>
					{title}
				</DialogTitle>
				{description ? (
					<DialogDescription asChild>
						<p className="mb-6 px-5 text-center text-xs leading-5 text-grey-500 md:text-sm md:leading-6">
							{description}
						</p>
					</DialogDescription>
				) : (
					<VisuallyHidden>
						<DialogDescription>{title}</DialogDescription>
					</VisuallyHidden>
				)}
				<Button onClick={onClose}>{t('common.gotIt')}</Button>
			</DialogContent>
		</Dialog>
	);
}

export default ErrorModal;
